<template>
  <div class="pp-stack" data-test="pp-tab-forms">
    <div v-if="formsSentence" class="pp-callout" data-test="pp-forms-pending">
      <i class="fa fa-wpforms pp-callout__ic" aria-hidden="true"></i>
      <span>
        <span class="pp-callout__t">Pending form or packet</span>
        <span class="pp-callout__s">{{ formsSentence }}</span>
      </span>
    </div>

    <PanelCard
      title="Form submissions"
      icon="fa-file-text-o"
      :count="rows.length || '—'"
      :table="rows.length > 0"
      test-id="pp-submissions"
    >
      <table v-if="rows.length" class="pp-tbl">
        <thead><tr><th>Form</th><th>Last updated</th></tr></thead>
        <tbody>
          <tr v-for="s in rows" :key="s.FormSubmissionIDForWeb">
            <td>
              <!-- A new tab, as on Patient Profile: the schedule stays where it was. -->
              <a
                :href="submissionHref(s.FormSubmissionIDForWeb)"
                target="_blank"
                rel="noopener"
                class="pp-link"
                data-test="pp-submission-link"
              >{{ s.Name || 'Form' }}</a>
            </td>
            <td class="pp-tbl__num">{{ when(s.DateUpdated) }}</td>
          </tr>
        </tbody>
      </table>
      <p v-else class="pp-empty">No forms submitted yet.</p>
    </PanelCard>
  </div>
</template>

<script>
/**
 * Forms — the patient's submissions (Patient Profile's own query) and, when the `forms` alert is
 * lit, what is still outstanding in the alert's own words.
 *
 * ⚠️ `DateUpdated` is the PATIENT's browser wall clock (see the Schedule View memory on form
 * times), so it is shown exactly as stored — never timezone-converted, which would shift it twice.
 *
 * ⛔ No prop named `patNum`, `siteID` or `loading` — mixin.js computeds silently replace them.
 */
import PanelCard from '../PanelCard.vue';
import { formatOdDateTime } from '@/utils/patientPanel/format';
import { describeAlert } from '@/utils/scheduleView/alerts';

export default {
  name: 'FormsTab',

  components: { PanelCard },

  props: {
    payload: { type: Object, default: () => ({}) },
    alertDetails: { type: Object, default: () => ({}) },
    dateFormat: { type: String, default: 'MM/DD/YYYY' },
  },

  computed: {
    rows() {
      return (this.payload && this.payload.formSubmissions) || [];
    },
    formsSentence() {
      if (!this.alertDetails || !this.alertDetails.forms) return '';
      return describeAlert('forms', this.alertDetails.forms);
    },
  },

  methods: {
    when(v) {
      return formatOdDateTime(v, this.dateFormat) || '—';
    },
    submissionHref(id) {
      const path = `/app/forms/view-submission/${encodeURIComponent(id)}`;
      return this.$router ? this.$router.resolve({ path }).href : path;
    },
  },
};
</script>
